import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { useCreateSurveyTemplate } from '@/features/surveys/api/use-create-template';
import { TemplateBuilderForm } from '@/features/surveys/components/TemplateBuilderForm';
import type { SurveyTemplateCreateInput } from '@/features/surveys/types';

export const Route = createFileRoute('/_authenticated/surveys/templates/new')({
  component: NewTemplatePage,
});

function NewTemplatePage() {
  const { t } = useTranslation('surveys');
  const navigate = useNavigate();
  const createMutation = useCreateSurveyTemplate();

  const handleSubmit = async (data: SurveyTemplateCreateInput) => {
    try {
      const result = await createMutation.mutateAsync(data);
      toast.success(t('toast.templateCreatedSuccessfully'));
      void navigate({ to: '/surveys/templates/$templateId', params: { templateId: result.id } });
    } catch {
      toast.error(t('toast.failedToCreateTemplate'));
    }
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{t('newTemplate.title')}</h1>
        <p className="text-muted-foreground">
          {t('newTemplate.description')}
        </p>
      </div>
      <TemplateBuilderForm
        mode="create"
        onSubmit={handleSubmit}
        onCancel={() => void navigate({ to: '/surveys' })}
        isPending={createMutation.isPending}
      />
    </div>
  );
}
